import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { Asphaltmill } from 'src/app/classes/asphaltmill.class';
import { Entity } from 'src/app/classes/entity.class';
import { PlanningHasEntity } from 'src/app/classes/planning-has-entity.class';
import { Planning } from 'src/app/classes/planning.class';
import { PlanningAsfaltteam } from 'src/app/classes/planningasfaltteam.class';
import { PlanningCutter } from 'src/app/classes/planningcutter.class';
import { PlanningDumper } from 'src/app/classes/planningdumper.class';
import { PlanningSet } from 'src/app/classes/planningset.class';
import { Status } from 'src/app/classes/status.class';
import { AsphaltService } from 'src/app/services/asphalt/asphalt.service';
import { EntitiesService } from 'src/app/services/entities/entities.service';
import { PlanningService } from 'src/app/services/planning/planning.service';
import { StatusService } from 'src/app/services/planning/status.service';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-planning-detail-print',
    templateUrl: './planning-detail-print.component.html',
    styleUrls: ['./planning-detail-print.component.scss'],
    standalone: false,
})
export class PlanningDetailPrintComponent implements OnInit {
    entitiesMap: Map<number, Entity>;
    planning: Planning;
    mainPlanning: PlanningCutter | PlanningHasEntity | PlanningAsfaltteam | PlanningSet | PlanningDumper;
    statusList: Status[];
    entities: Entity[];
    mills: Asphaltmill[];
    environment = environment;
    viewModel = {
        team: true,
        cutterList: true,
        wipertruckList: true,
    };
    private subscriptions = new Subscription();

    constructor(
        private planningService: PlanningService,
        private statusService: StatusService,
        private entitiesService: EntitiesService,
        private asphaltService: AsphaltService,
        private route: ActivatedRoute
    ) {}

    ngOnInit() {
        this.subscriptions.add(
            this.planningService.getSingle(+this.route.snapshot.params['id']).subscribe(planning => {
                this.planning = planning;
                this.mainPlanning = this.planningService.getMainPlanning(this.planning);

                setTimeout(() => {
                    (window as any).print();
                    (window as any).close();
                }, 1000);
            })
        );

        this.subscriptions.add(
            this.statusService.getList('planning').subscribe(statusList => {
                this.statusList = statusList;
            })
        );

        this.subscriptions.add(
            this.entitiesService.getList().subscribe(entities => {
                this.entities = entities;
            })
        );

        this.subscriptions.add(
            this.entitiesService.getMap().subscribe(entitiesMap => {
                this.entitiesMap = entitiesMap;
            })
        );

        this.asphaltService.getAsphaltMills$().subscribe(mills => {
            this.mills = mills;
        });
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
}
